import { useMutation } from '@tanstack/react-query';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/investor';
import { useNotification } from 'hooks/ui/useNotification';
import { api } from 'lib/httpClient';
import trpcApi from 'lib/trpcClient';

const useResendInvitesToInvestorsWithoutVisit = () => {
  const apiUtils = trpcApi.useUtils();
  const { success } = useNotification();
  const { error } = useNotification();

  return useMutation({
    mutationFn: async () => {
      const { data: response } = await api.post<
        ApiResponse<Api.SendInvitationsToInvestorsWithoutVisitResponse>
      >(`investor/resend-invitations-to-investors-without-visit`);
      return response.data;
    },
    onError: () => {
      error('Error when trying to resend platform invites.');
    },
    onSuccess: async (data) => {
      await apiUtils.investor.listInvestors.invalidate();
      await apiUtils.investor.getInvestor.invalidate();
      success(`Successfully sent ${data.invitesSent} investor invites.`);
    },
  });
};

const useInvestorPlatformInvites = () => {
  return {
    resendInvitesToInvestorsWithoutVisit:
      useResendInvitesToInvestorsWithoutVisit(),
  };
};

export default useInvestorPlatformInvites;
